import React, { useEffect, useState } from "react";
import { TrendingUp, ArrowDownToLine, Gift, ListChecks } from "lucide-react";
import api, { fmtINR } from "@/lib/api";

export default function AdminReports() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/reports/overview").then((res) => setR(res.data)); }, []);
  if (!r) return <div className="p-6 text-center text-slate-500">Loading...</div>;
  return (
    <div data-testid="admin-reports-page">
      <h1 className="text-3xl font-extrabold tracking-tight">Reports</h1>
      <p className="text-sm text-slate-500">High-level metrics across the tenant</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-5">
        <Card icon={TrendingUp} tone="emerald" label="Collections Total" value={fmtINR(r.collections_total)} />
        <Card icon={ListChecks} tone="primary" label="Collections Count" value={r.collections_count} />
        <Card icon={ArrowDownToLine} tone="rose" label="Withdrawals Total" value={fmtINR(r.withdrawals_total)} />
        <Card icon={Gift} tone="violet" label="Bonus Paid Total" value={fmtINR(r.bonus_paid_total)} />
      </div>
    </div>
  );
}

const Card = ({ icon: Icon, tone, label, value }) => {
  const t = { primary: "bg-blue-50 text-tenant-primary", emerald: "bg-emerald-50 text-emerald-600", violet: "bg-violet-50 text-violet-600", rose: "bg-rose-50 text-rose-600" }[tone];
  return (
    <div className="bg-white border border-slate-100 rounded-2xl p-5 card-shadow">
      <div className={`w-10 h-10 rounded-xl grid place-items-center ${t}`}><Icon className="w-5 h-5" /></div>
      <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-400 mt-3">{label}</div>
      <div className="text-xl font-extrabold tracking-tight mt-0.5">{value}</div>
    </div>
  );
};
